define('views/components/customer/customer_list',['require','views/base/list_view','views/components/customer/customer','text!templates/components/customer/customer_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/customer/customer');

    var temp = require("text!templates/components/customer/customer_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});

